
    import _Handlebars from 'handlebars/runtime';

    var Handlebars = _Handlebars.default;
    import "@canvas/i18n";
import "@canvas/handlebars-helpers/index.js";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = '/var/canvas/ui/features/calendar/jst/contextList';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helper, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, self=this, functionType="function";

function program1(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n  <li data-context=\"";
  if (helper = helpers.asset_string) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.asset_string); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" class=\"context_list_context hover-container\" style=\"display:flex;\">\n    <span class=\"context-list-toggle-box group_";
  if (helper = helpers.asset_string) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.asset_string); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" aria-labelledby=\"group_";
  if (helper = helpers.asset_string) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.asset_string); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "_checkbox_label\"\n      tabindex=\"0\" role=\"checkbox\" style=\"flex-shrink:0;\"\"></span>\n    <label id=\"group_";
  if (helper = helpers.asset_string) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.asset_string); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "_checkbox_label\" style=\"flex-grow:1;\">\n      ";
  if (helper = helpers.name) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.name); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\n    </label>\n    ";
  stack1 = (helper = helpers.ifEqual || (depth0 && depth0.ifEqual),options={hash:{},inverse:self.noop,fn:self.program(2, program2, data),data:data},helper ? helper.call(depth0, (depth0 && depth0.type), "account", options) : helperMissing.call(depth0, "ifEqual", (depth0 && depth0.type), "account", options));
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    <div class=\"buttons-wrapper\" style=\"flex-shrink:0;\">\n    ";
  stack1 = (helper = helpers.ifEqual || (depth0 && depth0.ifEqual),options={hash:{},inverse:self.noop,fn:self.program(6, program6, data),data:data},helper ? helper.call(depth0, (depth0 && depth0.type), "account", options) : helperMissing.call(depth0, "ifEqual", (depth0 && depth0.type), "account", options));
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    <button type=\"button\" tabindex=\"0\" class=\"Button Button--icon-action ContextList__MoreBtn\">\n      <i class=\"icon-more\" aria-hidden=\"true\"></i>\n      <span class=\"screenreader-only\">\n        "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'name': ((depth0 && depth0.name)),
    'i18n_inferred_key': (true),
    'i18n_scope': ("calendar.context_list")
  },data:data},helper ? helper.call(depth0, "open_name_color_picker_a2646a33", "Open %{name} Color Picker", options) : helperMissing.call(depth0, "t", "open_name_color_picker_a2646a33", "Open %{name} Color Picker", options)))
    + "\n      </span>\n    </button>\n    </div>\n  </li>\n  ";
  return buffer;
  }
function program2(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n      ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.auto_subscribe), {hash:{},inverse:self.noop,fn:self.program(3, program3, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    ";
  return buffer;
  }
function program3(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n       ";
  stack1 = helpers.unless.call(depth0, (depth0 && depth0.viewed_auto_subscribed_account_calendars), {hash:{},inverse:self.noop,fn:self.program(4, program4, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n      ";
  return buffer;
  }
function program4(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n          <div class=\"new-feature-pill\" style=\"flex-shrink:0; align-self:start;\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("calendar.context_list")
  },data:data},helper ? helper.call(depth0, "new_13daf639", "New", options) : helperMissing.call(depth0, "t", "new_13daf639", "New", options)))
    + "</div>\n        ";
  return buffer;
  }

function program6(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n      ";
  stack1 = helpers.unless.call(depth0, (depth0 && depth0.auto_subscribe), {hash:{},inverse:self.noop,fn:self.program(7, program7, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    ";
  return buffer;
  }
function program7(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n        <button type=\"button\" tabindex=\"0\" class=\"Button Button--icon-action ContextList__DeleteBtn\">\n          <span aria-hidden=\"true\"><i class=\"icon-x\"></i></span>\n          <span class=\"screenreader-only\">\n            "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'name': ((depth0 && depth0.name)),
    'i18n_inferred_key': (true),
    'i18n_scope': ("calendar.context_list")
  },data:data},helper ? helper.call(depth0, "remove_name_calendar_bdc329d9", "Remove %{name} Calendar", options) : helperMissing.call(depth0, "t", "remove_name_calendar_bdc329d9", "Remove %{name} Calendar", options)))
    + "\n          </span>\n        </button>\n      ";
  return buffer;
  }

  buffer += "<ul id=\"";
  if (helper = helpers.type) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.type); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "-context-list\">\n  ";
  stack1 = helpers.each.call(depth0, (depth0 && depth0.contexts), {hash:{},inverse:self.noop,fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n</ul>\n<div id=\"";
  if (helper = helpers.type) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.type); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "_color_picker_holder\"></div>";
  return buffer;
  });
    ;
    ;
    export default templates[name];
  